<template>
  <div class="sn-f-b-s video">
    <sn-navigator id="JKJT" :initial="perpetual.FUNCTION_ID_ZJJT"></sn-navigator>
    <div class="sn-f-1 sn-f-s-1 sn-f-col-b-s video-region">
      <sn-breadcrumb :breadcrumb="[{ title: '首页' }, { title: $sn.utils.getFunctionTitle('0', perpetual.FUNCTION_ID_ZJJT), router: '/lecture/homepage' }, { title: '视频详情' }]"></sn-breadcrumb>
      <div class="sn-f-1 video-blank" v-if="!$sn.validate.empty(course)">
        <div class="sn-f-c-c sn-fw-bold sn-fs-28 sn-fc-text1">{{course.title}}</div>
        <div class="sn-f-c-c video-sub-title">
          播放 {{course.viewerCount}} 次 <span v-if="parseInt(course.sectionNum) > 1">共 {{chapterArray.length}} 课</span>
        </div>
        <div class="roll-region">
          <div class="video-content">
            <div class="content-left" :class="{'width-special': parseInt(course.sectionNum) < 2}">
              <div class="sn-f-c-c left-video">
                <template v-if="parseInt(course.sectionNum) < 2">
                  <video id="myVideo" ref="video" @loadedmetadata="getVideoDimensions"
                         :style="{'width': videoWidth < 1000 ? (videoWidth + 'px') : '100%', 'height': videoHeight < 550 ? (videoHeight + 'px') : '550px', 'object-fit': 'fill'}"
                         :src="video.src" :poster="video.poster" :autoplay="video.autoPlay" @ended ="onEnded" @pause="isDisplayBlockCircle = true" @play="onPlay" @error="isDisplayBlockCircle = true" controls></video>
                </template>
                <template v-else>
                  <video id="myVideo" ref="video" @loadedmetadata="getVideoDimensions"
                         :style="{'width': videoWidth < 750 ? (videoWidth + 'px') : '100%', 'height': videoHeight < 550 ? (videoHeight + 'px') : '550px', 'object-fit': 'fill'}"
                         :src="video.src" :poster="video.poster" :autoplay="video.autoPlay" @ended ="onEnded" @pause="isDisplayBlockCircle = true" @play="onPlay" @error="isDisplayBlockCircle = true" controls></video>
                </template>
                <div class="iconfont icon-bofanganniu" v-if="isDisplayBlockCircle" @click="onPlay"></div>
                <div class="sn-f-c-c play-complete-blank" v-if="isPlayComplete && parseInt(course.sectionNum) > 1">
                  <div class="sn-f-b-c" :class="{'sn-ph-10': parseInt(course.sectionNum) > 1}" @click="playNext('')">重新播放</div>
                  <div class="sn-f-b-c" :class="{'sn-ph-10': parseInt(course.sectionNum) > 1}" v-if="parseInt(course.sectionNum) > 1" @click="playNext(1)">
                    <span class="padding10Horizontal-blank">{{countSecond}}</span>秒后播放下一个
                  </div>
                </div>
              </div>
            </div>
            <div class="content-right" v-if="parseInt(course.sectionNum) > 1">
              <div class="chapter-single" :class="{'sn-fc-white sn-bc-main': chapter.id === section.id}"
                   v-for="(chapter, index) in chapterArray" :key="chapter.id" @click="selectSection(chapter)">
                <div class="title-left">第{{(index + 1) | numberToChinese}}节</div>
                <div class="title-right">{{chapter.title}}</div>
              </div>
            </div>
          </div>
          <div class="box-title">{{ courseType === 'VIDEO' ? '视频介绍' : '课程介绍' }}</div>
          <div class="introduce-box" v-if="course.description" v-html="course.description"></div>
        </div>
      </div>
      <sn-no-data v-else></sn-no-data>
    </div>
  </div>
</template>
<script type="text/javascript">
import Swagger from '@/common/utils/swagger';
import * as Messages from '@/common/utils/messages';
import * as Constants from '@/common/utils/constants';

export default {
  data() {
    return {
      perpetual: Constants,
      course: {},
      chapterArray: [],
      section: {},
      video: {
        src: '', // 要播放视频的资源地址，支持网络地址，支持优酷视频编码（支付宝客户端 10.1.75）。
        poster: '', // 视频封面图的 url，支持 jpg、png 等图片，如 https://***.jpg。如果不传的话，默认取视频的首帧图作为封面图
        autoPlay: false // autoplay 是否自动播放。。
      },
      isPlayComplete: false, // 是否播放完成
      countSecond: 0, // 倒计时秒数
      isDisplayBlockCircle: true, // 是否显示播放按钮
      intervalId: null,
      courseType: '',
      videoWidth: 0,
      videoHeight: 0
    };
  },
  computed: {},
  watch: {
    // 目前选择播放的章节
    section: function(section) {
      // 加载章节视频
      if (this.$sn.validate.empty(section)) return false;
      if (section.id) {
        this.video.autoPlay = true;
        if (section.cover.substring(0, 4) === 'http' || section.cover.substring(0, 7) === '/static' || section.cover.substring(0, 2) === '//') {
          this.video.poster = section.cover;
        }
        else {
          this.video.poster = this.perpetual.ALI_CLOUD_DOMAIN_STATIC + section.cover;
        }
        if (section.playUrl.substring(0, 4) === 'http' || section.playUrl.substring(0, 7) === '/static' || section.playUrl.substring(0, 2) === '//') {
          this.video.src = section.playUrl;
        }
        else {
          this.video.src = this.perpetual.ALI_CLOUD_DOMAIN_STATIC + section.playUrl;
        }
      }
    }
  },
  created: function() {
    document.title = '视频详情';
    this.$route.meta.title = '视频详情';
    this.courseType = this.$route.query.courseType ? this.$route.query.courseType : '';
    if (this.$route.query.id) this.initialVideo(this.$route.query.id);
  },
  filters: {
    // 将数字转换为中文
    numberToChinese(num) {
      const single = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
      let value = '';
      if (num.toString().length === 1) value = single[num];
      else if (num.toString().length === 2) {
        const arr = num.toString().split('');
        if (arr[0] === '1') value = '十' + single[parseInt(arr[1])];
        else value = single[parseInt(arr[0])] + '十' + single[parseInt(arr[1])];
      }
      return value;
    }
  },
  methods: {
    getVideoDimensions() {
      const video = this.$refs.video;
      this.videoWidth = video.videoWidth; // 视频流的宽度
      this.videoHeight = video.videoHeight; // 视频流的高度
    },
    // 获取视频
    initialVideo(id) {
      let title = Swagger.getLectureGeneralDetail;
      if (this.courseType === 'VIDEO') {
        title = Swagger.getLectureVideoDetail;
      }
      const params = {
        url: this.$sn.format.caption(title, [id]),
        query: {}
      };
      this.$sn.assembly.loading(true);
      this.$sn.utils.ordinaryRequest(params).then(result => {
        this.$sn.assembly.loading(false);
        if (result && result.code === 0 && result.data) {
          this.course = result.data;
          this.chapterArray = this.course.sections;
          if (this.chapterArray && this.chapterArray.length > 0) {
            for (let i = 0; i < this.chapterArray.length; i++) {
              this.chapterArray[i].index = i;
            }
            this.section = this.chapterArray[0];
          }
          else {
            if (this.course.cover.substring(0, 4) === 'http' || this.course.cover.substring(0, 7) === '/static' || this.course.cover.substring(0, 2) === '//') {
              this.video.poster = this.course.cover;
            }
            else {
              this.video.poster = this.perpetual.ALI_CLOUD_DOMAIN_STATIC + this.course.cover;
            }
          }
        }
        else this.$sn.assembly.toast({ caption: result && result.msg ? result.msg : Messages.C001 });
      });
    },
    // 播放事件
    onPlay() {
      const myVideo = document.getElementById('myVideo');
      this.isDisplayBlockCircle = false;
      this.isPlayComplete = false;
      myVideo.play();
    },
    // 播放完成事件
    onEnded() {
      this.isPlayComplete = true;
      this.video.autoPlay = false;
      this.isDisplayBlockCircle = true;
      this.countSecond = 5;
      this.startCountDown();
    },
    /**
     * 重新播放
     * @param {number} type 1:下一个 0:上一个 空:重新播放
     */
    playNext(type) {
      clearInterval(this.intervalId);
      // 判断this.section对象中是否包含type这个键
      if (Object.keys(this.section).includes('type')) {
        if (this.section.type) this.section.type = '';
        else this.section.type = '1';
      }
      else this.$set(this.section, 'type', '');
      this.countSecond = '';
      const index = (type ? (this.section.index + 1) : this.section.index) % this.chapterArray.length;
      this.isPlayComplete = false;
      this.section = this.chapterArray[index];
      if (this.$sn.validate.empty(type)) this.onPlay();
    },
    // 选择了某一节课程
    selectSection(section) {
      this.isPlayComplete = false;
      this.section = section;
    },
    // 倒计时
    startCountDown() {
      this.intervalId = setInterval(() => {
        if (this.countSecond > 0) this.countSecond--; // 每隔1秒将倒计时减少1
        else {
          clearInterval(this.intervalId);
          const index = (this.section.index + 1) % this.chapterArray.length;
          this.isPlayComplete = false;
          this.section = this.chapterArray[index];
        }
      }, 1000);
    }
  },
  beforeDestroy() {
    if (this.intervalId) clearInterval(this.intervalId);
  }
};
</script>
<style lang="scss" scoped>
.video {
  overflow-y: hidden;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  background: $white;
  left: 0;
  top: 0;

  &-region {
    height: 100%;

    .video-blank {
      overflow: hidden;
      display: flex;
      flex-direction: column;
      height: 100%;
      width: 100%;
      padding: 20px 20px 0;

      .video-sub-title {
        @include fs(16);

        color: $text6;
        margin-top: 5px;
      }

      .roll-region {
        overflow-y: auto;
        flex: 1;
        padding-bottom: 10px;

        .video-content {
          @include fs(14);

          margin-top: 10px;
          width: 100%;
          display: flex;
          justify-content: space-between;

          .content-left {
            width: 60%;
            height: 100%;
            border-radius: 8px;

            .left-video {
              position: relative;
              width: 100%;
              height: 100%;

              video {
                border-radius: 8px;
                width: 100%;
                height: auto;
                object-fit: fill;
              }

              .icon-bofanganniu {
                font-size: 50px;
                position: absolute;
                top: 40%;
                bottom: 50%;
                left: 50%;
                right: 50%;
                margin: auto;
                z-index: 11;
              }
            }
          }

          .content-right {
            width: 38%;
            overflow-y: scroll;
            max-height: 340px;

            .chapter-single {
              @include fs(20);

              background-color: $background1;
              margin-bottom: 10px;
              border-radius: 8px;
              padding: 20px;
              display: flex;
              justify-content: space-between;

              .title-left {
                align-self: flex-start;
              }

              .title-right {
                margin-left: 10px;
                flex: 1;
              }
            }
          }
        }

        .box-title {
          border-bottom: 3px $main solid;
          overflow: hidden;
          margin-top: 20px;
        }

        .introduce-box {
          margin: 12px;
        }

        .play-complete-blank {
          background-color: $mask;
          position: absolute;
          width: 100%;
          height: auto;
          z-index: 10;
          top: 0;
          bottom: 0;
          color: $white;
          font-size: 40px;
        }
      }
    }
  }

  .width-special {
    width: 100% !important;
  }
}
</style>
